import { render, staticRenderFns } from "./groupHeader.vue?vue&type=template&id=08c2ff4a&scoped=true&"
import script from "./groupHeader.vue?vue&type=script&lang=js&"
export * from "./groupHeader.vue?vue&type=script&lang=js&"
import style0 from "./groupHeader.vue?vue&type=style&index=0&id=08c2ff4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2ff4a",
  null
  
)

export default component.exports